import { PessoasModel } from "model/api/gestao/pessoa/pessoas-model";
import { CardNaoEncontrado } from "views/components/cards";
import { CardAgenteExterno } from "views/components/cards/card-agente-externo";
import { InformacaoIcon } from "views/components/icons";

export interface AgenteExternoListDataProps {
  list: Array<PessoasModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (id: string) => any;
  onCardChecked: (id: string) => any;
  label: string
}

export const AgenteExternoListData = (props: AgenteExternoListDataProps) => {

  const onCardSelected = (id: string) => {
    props.onCardSelected(id);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem={`Nenhum ${props.label} Encontrado.`}
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props?.list.length > 0 &&
        props.list.map((clientes, index) => {
          return (
            <CardAgenteExterno
              selected={
                props.selectedList.filter((item) => item === clientes.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={clientes}
              key={index}
            />
          );
        })}
    </>
  );
};
